import { createUseStyles } from 'react-jss';

import { MENU_COLLAPSE_BREAKPOINT } from '../SingleToolNavigation';
import { ITheme, mediaQuery } from '../../../styles';

const MAX_WIDTH = 1440;
const HEADER_OFFSET = 24;

const useStyles = createUseStyles<string, { noBorder: boolean }, ITheme>(
  ({ breakpoints }: ITheme) => ({
    root: {
      position: 'sticky',
      top: 0,
      backgroundColor: 'white',
      zIndex: 107,
      boxShadow: ({ noBorder }) => (noBorder ? 'none' : '0px 0.5px 0px var(--x-border-2)'),

      [mediaQuery(breakpoints.mobile)]: {
        padding: '0px 24px',
      },
    },

    container: {
      padding: `0 ${HEADER_OFFSET}px`,
      display: 'flex',
      alignItems: 'center',
      height: 80,
      justifyContent: 'space-between',
      maxWidth: MAX_WIDTH,
      margin: 'auto',

      [mediaQuery(breakpoints.mobile)]: {
        padding: '0px',
      },
    },
    logo: {
      marginRight: 0,
    },
    navContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    buttonsContainer: {
      alignItems: 'center',
      display: 'flex',
      gap: 12,

      [mediaQuery(MENU_COLLAPSE_BREAKPOINT)]: {
        marginLeft: 'auto',
      },
    },
  }),
  { name: 'SingleToolHeader' },
);

export default useStyles;
